import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'font-awesome/css/font-awesome.min.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
</React.StrictMode>,
  document.getElementById('root')
);

const hideSplash = () => {
  const splash = document.getElementById('app-splash')
  if (!splash) return
  splash.classList.add('isGone')
  window.setTimeout(() => splash.remove(), 400)
}

const isWebApp = document.documentElement.classList.contains('isWebApp')
if (isWebApp) window.addEventListener('load', () => window.setTimeout(hideSplash, 3200))
else hideSplash()

window.addEventListener('error', (event) => {
  const el = event.target
  if (!el || (el.tagName !== 'IMG' && el.tagName !== 'VIDEO' && el.tagName !== 'AUDIO')) return
  const src = el.currentSrc || el.src
  if (!src || src.indexOf('/api/uploads/') === -1) return
  const tries = Number(el.dataset.mediaTries || 0)
  if (tries >= 2) return
  el.dataset.mediaTries = String(tries + 1)
  const clean = src.replace(/([?&])retry=\d+/, '').replace(/[?&]$/, '')
  const next = `${clean}${clean.indexOf('?') === -1 ? '?' : '&'}retry=${tries + 1}`
  window.setTimeout(() => {
    el.src = next
    if (typeof el.load === 'function') el.load()
  }, 400 * (tries + 1))
}, true)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/custom-ws.js', { scope: '/' }).catch(() => {})
  })
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
